module.exports = __webpack_public_path__ + "img/4.eb87148b.jpg";